// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var PageUITitle = require("../../components/PageTitle/PageUITitle.bs.js");
var UserSession = require("../../reason/common/UserSession/UserSession.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
var SubusersAddUserForm = require("./SubusersAddUserForm.bs.js");
var SubusersPageAccountsList = require("./SubusersPageAccountsList.bs.js");
var MarkupHelpers = require("components/MarkupHelpers");
var SubusersPageRelayQuery_graphql = require("../../__generated__/SubusersPageRelayQuery_graphql.bs.js");

var convertVariables = SubusersPageRelayQuery_graphql.Internal.convertVariables;

var convertResponse = SubusersPageRelayQuery_graphql.Internal.convertResponse;

var convertWrapRawResponse = SubusersPageRelayQuery_graphql.Internal.convertWrapRawResponse;

var use = RescriptRelay_Query.useQuery(convertVariables, SubusersPageRelayQuery_graphql.node, convertResponse);

var useLoader = RescriptRelay_Query.useLoader(convertVariables, SubusersPageRelayQuery_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded = RescriptRelay_Query.usePreloaded(SubusersPageRelayQuery_graphql.node, convertResponse, (function (prim) {
        return prim;
      }));

var $$fetch = RescriptRelay_Query.$$fetch(SubusersPageRelayQuery_graphql.node, convertResponse, convertVariables);

var fetchPromised = RescriptRelay_Query.fetchPromised(SubusersPageRelayQuery_graphql.node, convertResponse, convertVariables);

var retain = RescriptRelay_Query.retain(SubusersPageRelayQuery_graphql.node, convertVariables);

var Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  $$fetch: $$fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function SubusersPageRelay(props) {
  var data = use(undefined, undefined, undefined, undefined);
  var match = UserSession.useAgentInfoOpt();
  var currentUserRole = match !== undefined ? match.membership.role : undefined;
  var match$1 = data.currentAccountV5;
  if (match$1 === undefined) {
    return null;
  }
  var fragmentRefs = match$1.fragmentRefs;
  return JsxRuntime.jsxs(MarkupHelpers.ContentBox, {
              paddingFull: true,
              hasShadow: true,
              children: [
                JsxRuntime.jsx(PageUITitle.make, {
                      title: "Users"
                    }),
                JsxRuntime.jsx(SubusersPageAccountsList.make, {
                      account: fragmentRefs,
                      currentUserRole: currentUserRole
                    }),
                JsxRuntime.jsx(SubusersAddUserForm.make, {
                      account: fragmentRefs,
                      currentUserRole: currentUserRole
                    })
              ]
            });
}

var make = SubusersPageRelay;

exports.Query = Query;
exports.make = make;
/* use Not a pure module */
